import { Observable, of } from 'rxjs';
import { UrlBuilder } from '../core';
import { Category } from '../documents';

export class NotificationBarItem {
    public url: string[];

    private totalCounter: Observable<number>;

    public get categoryName(): string { return this.category.name; }

    public get categoryClassName(): string { return this.category.categoryId; }

    public get counter(): Observable<number> { return this.totalCounter; }

    public get icon(): string { return this.category.icon; }

    public get showCounter(): boolean { return !!this.unreadCounter; }

    public get disabled() {
        return !this.totalDocs;
    }

    constructor(
        private category: Category,
        private urlBuilder: UrlBuilder,
        private totalDocs: number,
        private unreadCounter?: number
    ) {
        this.totalCounter = of(unreadCounter);

        this.url = this.createUrl();
    }

    private createUrl(): string[] {
        return this.category.children.length
            ? this.urlBuilder
                .esa()
                .globalPopup()
                .generalDocuments(this.category)
                .category(this.category.children[0])
                .url()
            : this.urlBuilder
                .esa()
                .globalPopup()
                .generalDocuments(this.category)
                .url();
    }
}